module.exports = __webpack_public_path__ + "static/media/carboculture-logo.57ce1b6e.svg";